import { useReveal } from "@/hooks/useReveal";
import { cn } from "@/lib/utils";

interface RevealSectionProps {
  children: React.ReactNode;
  className?: string;
  /** Delay in ms for stagger effect */
  delay?: number;
  /** Direction of entrance */
  direction?: "up" | "down" | "left" | "right";
}

const translateMap = {
  up: "translate-y-6",
  down: "-translate-y-6",
  left: "translate-x-6",
  right: "-translate-x-6",
};

const RevealSection = ({
  children,
  className,
  delay = 0,
  direction = "up",
}: RevealSectionProps) => {
  const { ref, revealed } = useReveal();

  return (
    <div
      ref={ref}
      className={cn(
        "transition-all duration-700 ease-[cubic-bezier(0.22,1,0.36,1)]",
        revealed
          ? "opacity-100 translate-x-0 translate-y-0"
          : `opacity-0 ${translateMap[direction]}`,
        className
      )}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
};

export default RevealSection;
